import WrittenReview from './WrittenReviewContainer';

export default WrittenReview;
